<template>
    <div align="left" class="mg_left_0 event__content" style="vertical-align: middle">
        <!-- <q-icon name="img:/assets/images/icon/icon_write.png" size="40px" style="margin-bottom: 4px" /> -->
        <q-icon v-if="getType === 100" name="img:/assets/images/icon/icon_clap.svg" class="mapEventIcon30" />
        <q-icon v-if="getType === 200" name="img:/assets/images/icon/ico_reset.svg" class="mapEventIcon30" />
        <q-icon v-if="getType === 300" name="img:/assets/images/icon/ico_reset.svg" class="mapEventIcon30" />
        <q-icon v-if="getType === 400" name="img:/assets/images/icon/ico_write.png" class="mapEventIcon30" />
        <!-- <q-chip square outline color="primary" size="md">{{ props.date }}</q-chip> -->
        <!-- <span class="mapBoxTtMoon"> 박나래 선생님이 비문학을 추전학습으로 생성하였습니다. </span> -->
        <span class="mapBoxTtMoon">{{ props.one.contents }} </span>
        <!-- <div class="barVertical" /> -->
        <span class="mapBoxTtLevles"> {{ props.date }}</span>
    </div>
</template>
<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';

const props = defineProps({
    date: {
        Type: String,
        required: true,
    },
    one: {
        Type: Object,
        required: true,
    },
});

// const text = '어떤 선생이 수정하였다.';
// const cutText = text.split('선생')[1].includes('수정');
// console.log(' cutTextcutTextcutText', cutText);

const getType = computed(() => {
    const cutText = props.one.contents;
    // console.log('props.one.contents', text);

    // 아무개 선생님이 1레벨 3레슨 문학을 추천학습으로 생성하였습니다."
    // 아무개 선생님이 1레벨 2레슨으로 진도를 수정하였습니다."
    // 아무개 선생님이 1레벨 2레슨 문학 지문 1을 리셋 하였습니다."
    // 아무개 선생님이 1레벨 2회차 수능모의평가를 리셋 하였습니다."
    // const cutText = text.split('선생님')[1];
    // console.log('cutText :', cutText);
    if (cutText.includes('생성')) return 100;
    if (cutText.includes('리셋')) return cutText.includes('수능모의평가') ? 200 : 300;
    if (cutText.includes('수정')) return 400;
    // if (cutText) {
    //     if (cutText.includes('생성')) return 100;
    //     if (cutText.includes('수정')) return 200;
    //     if (cutText.includes('리셋')) return 300;
    // }
    return null;
});

// watch(props.kind, (newProps, oldProps) => {
//     console.log('--watch-props-newProps', newProps);
//     console.log('--watch-props-oldProps', oldProps);
// });

// const kind = computed(() => props.kind);

onMounted(() => {
    // console.log('--one-props-', props.one);
});
////////////////////////////----OnClick----////////////////////////////
// const onMㄴㅇㄹㅇㄴㄹㄴㅇㄹInfo = () => {};
</script>

<style scoped lang="scss">
.gray {
    color: #8e8e8e;
}

.mapEventIcon30 {
    top: -6px;
    margin: 0 10px;
    width: 40px;
    height: 100%;
}

.event__content {
    .mapBoxTtMoon {
        margin: 0;
    }

    .mapBoxTtLevles {
        margin-left: 1.67vmin;
    }
}
</style>
